<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AkF8hH/tc-custom/9781945448096.jpg?1685327423916" alt="This image is the cover for the book Broken Slate, The Sean Coleman Thriller series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Broken Slate, The Sean Coleman Thriller series
      </h1>
      <p class="bookDescription body article font2">
        <b>Be careful the legacy you wish for.<br/><br/>"John Daly has a magical writing style...You won't want to put it down." - <i>Dana Perino, Former White House press secretary</i><br/><br/>"... John A. Daly writes with assurance and style --and without fear or political correctness...an engrossing thriller..." - <i>James Rosen, Fox News chief Washington correspondent and author of THE STRONG MAN and CHENEY ONE ON ONE</i></b><br/><br/>Thirty years ago, Sean Coleman's father abandoned his family in the Colorado mountain town of Winston, and was never heard from again. The reason for his disappearance was always a mystery, but a lifetime of blaming himself put Sean on a rough, dark path that took him years to return from. Now content in his life, Sean receives unexpected word that his father has finally reemerged, on the other side of the country in Pawleys Island, South Carolina. . .as a murder victim. <br/><br/>At the wishes of his sister, Sean flies out to retrieve the body, and hopefully find answers to why his father left, and the life he went on to lead. What Sean discovers is a second family, a web of deception, and a brutal killer who's still on the loose. . .and isn't finished killing.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John A. Daly
      </h2>
      
      <p class="authorDescription body article">A lifelong Coloradoan, John A. Daly graduated from the University of Northern Colorado with a degree in business administration and computer information systems. With a thirst for creative expression that went beyond the logic and absolutes of computer programming, John developed an interest in writing. He currently writes political, cultural, and media analysis columns for multiple national news websites, when he's not working on the next Sean Coleman thriller.</p>
      
      
         <a class="authorURL body link" href="http://www.johndalybooks.com/" target="_blank">
      
              About Author
         </a>
         <br/>
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Boutique of Quality Books Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1f833353